import NotFound from "@/views/public/NotFoundView";
import ErrorView from "@/views/public/ErrorView";
import InviteView from "@/views/public/InviteView.vue";

import gettext from "@/language";

export default [
  {
    path: "/invite/:uuid",
    name: "invite",
    component: InviteView,
    meta: {
      title: gettext.$gettext("Invite"),
      public: true,
    },
  },
  {
    path: "/error",
    name: "error",
    component: ErrorView,
    meta: {
      title: gettext.$gettext("Error"),
      public: true,
    },
  },
  {
    path: "/404",
    name: "404",
    component: NotFound,
    meta: {
      title: gettext.$gettext("Not found"),
      public: true,
    },
  },
];
